import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Sort } from '@angular/material/sort';
import { debounceTime } from 'rxjs/operators';
import { compare } from 'src/app/globals';
import { OfferService } from 'src/app/lib/offer/services/offer.service';
import { Product } from 'src/app/lib/product/classes';
import { HiddenInputDirective } from 'src/app/lib/shared/directives/hidden-input.directive';
import { OfferItem } from '../../../classes';

@Component({
  selector: 'app-offer-items-form2',
  templateUrl: './offer-items-form2.component.html',
  styleUrls: ['./offer-items-form2.component.css']
})
export class OfferItemsForm2Component implements OnInit {

  @Input() disabled: boolean = false;
  @Input() showFooter: boolean = true;
  @Input() columns: string[] = ['position', 'term', 'count', 'product', 'description', 'info', 'setupcost', 'rentalcost', 'purchasecost', 'controls'];

  footerColumns: string[] = ['position', 'setupcost', 'rentalcost', 'purchasecost', 'controls'];
  numberTypes: string[] = ['itemposition', 'itemcount', 'itemsetupcost', 'itemrentalcost', 'itempurchasecost'];

  totalRentalCost: number = 0;
  totalPurchaseCost: number = 0;
  totalSetupCost: number = 0;

  updateItemOnProductChange: boolean = true;

  formGroup: FormGroup;

  constructor(
    private _controlContainer: ControlContainer,
    private _formBuilder: FormBuilder,
    private _offerService: OfferService
  ) { }

  addArticle() {
    this.itemControl.push(this._formBuilder.group(new OfferItem()));
  }

  itemIsEmpty(item: OfferItem): boolean {
    console.log(item);
    return !item || (!item.itemdesc && !item.itemproduct && !item.itemterm && !item.iteminfo && !item.itempurchasecost && !item.itemrentalcost && !item.itemsetupcost!);
  }

  itemProductChanged(product: Product, group: FormGroup) {
    if (
      this.updateItemOnProductChange
      && product
      && !group.controls['itemterm'].value
      && !group.controls['itemdesc'].value
      && !group.controls['itempurchasecost'].value
      && !group.controls['itemrentalcost'].value
      && !group.controls['itemsetupcost'].value
    ) {
      group.controls['itemterm'].setValue(product.productservice);
      group.controls['itemdesc'].setValue(product.productdesc);
      group.controls['itempurchasecost'].setValue(product.productpurchasecost);
      group.controls['itemrentalcost'].setValue(product.productrentalcost);
      group.controls['itemsetupcost'].setValue(product.productsetupcost);
      this.updateCosts();
    }
  }

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as FormGroup;

    this.formGroup
      .valueChanges
      .pipe(debounceTime(200))
      .subscribe({ next: () => this.updateCosts() });

    this.updateCosts();
  }

  normalizePositions() {
    var position = 1;
    for (let index in this.itemControl.controls) {
      (this.itemControl.controls[index] as FormGroup)
        .controls['itemposition']
        .setValue(position);
      position++;
    }
  }

  proxyFocus(ref: HiddenInputDirective) {
    ref.focus();
  }

  removeEmptyItems() {
    if (this.itemControl.length === 0) return;

    var index = 0;

    var currentItem = this
      .itemControl
      .controls[index];

    while (currentItem) {
      if (this.itemIsEmpty(currentItem.value)) {
        this.removeItem(index);
      } else index++;
      currentItem = this
        .itemControl
        .controls[index];
    }
  }

  removeItem(key: number) {
    if (this.itemControl.controls[key]) {
      this.itemControl.removeAt(key);
      this.updatePurchaseCost();
      this.updateRentalCost();
      this.updateSetupCost();
    }
  }

  sortData(sort: Sort) {
    if (!sort.active || sort.direction === '') {
      this.sortData({ 'active': 'itemposition', 'direction': 'asc' });
      return;
    }
    const isAsc = sort.direction === 'asc';
    let data: FormGroup[] = this
      .itemControl
      .controls as FormGroup[];
    let sorted = data.sort((a, b) => {
      return this.numberTypes.includes(sort.active) ? compare(parseInt(a.controls[sort.active].value), parseInt(b.controls[sort.active].value), isAsc) : compare(a.controls[sort.active].value, b.controls[sort.active].value, isAsc);
    });
    for (let index in sorted) {
      this
        .itemControl
        .setControl(parseInt(index), data[index]);
    }
  }

  updateCosts() {
    this.updatePurchaseCost();
    this.updateRentalCost();
    this.updateSetupCost();
  }

  updateRentalCost() {
    this.totalRentalCost = (this.itemControl.value as OfferItem[]).reduce((agg, curr) => agg += curr.itemrentalcost * (typeof curr.itemcount === 'number' && curr.itemcount > 0 ? curr.itemcount : 1), 0);
  }

  updatePurchaseCost() {
    this.totalPurchaseCost = (this.itemControl.value as OfferItem[]).reduce((agg, curr) => agg += curr.itempurchasecost * (typeof curr.itemcount === 'number' && curr.itemcount > 0 ? curr.itemcount : 1), 0);
  }

  updateSetupCost() {
    this.totalSetupCost = (this.itemControl.value as OfferItem[]).reduce((agg, curr) => agg += curr.itemsetupcost * (typeof curr.itemcount === 'number' && curr.itemcount > 0 ? curr.itemcount : 1), 0);
  }

  get itemControl(): FormArray {
    return this.formGroup.controls['items'] as FormArray;
  }

}
